
export const DEVELOPER_NOTES_API_ENDPOINTS = {
    
}